var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-background",style:({
    'background-image': _vm.option.back_img ? ("url(" + (_vm.option.back_img) + ")") : ''
  })},[_c('div',{staticClass:"slider-list",style:({
      width: _vm.listWidth,
      transition: _vm.transition,
      transform: _vm.transform
    })},[_vm._t("default")],2),_c('div',{staticClass:"coverup",style:({
      'background-image': _vm.option.front_img ? ("url(" + (_vm.option.front_img) + ")") : ''
    }),on:{"touchstart":_vm.onTouchStart,"touchmove":_vm.onTouchMove,"touchend":_vm.onTouchEnd,"!click":function($event){return _vm.coverupJumpLogic($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }